<template>
  <div id="app">
	   <keep-alive>
				<router-view v-if="$route.meta.keepAlive"></router-view>
		</keep-alive>
		<router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import '../src/assets/CSS/swiper.css'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)
Vue.use(VueAxios, axios)


export default {
  name: 'App',
}
</script>

<style lang="less">
@import "./assets/CSS/reset.css";  
@import "./assets/CSS/committeeStyle.css";  
@import "./assets/CSS/font-committee-icon.css";
@import "./assets/CSS/swiper-page.css";

  html{
    padding: 0;
    margin: 0;
    body{
      padding: 0;
      margin: 0;
    }
  }
  .swal2-popup{
		background-color: #f7f7f7;
		padding: 1.75em 1.55em 0.35em;
	}
	.swal2-popup .swal2-title{
		font-size: 18px;
		font-weight: 500;
		color: #484848;
		margin-bottom: 15px;
	}
	.swal2-popup .swal2-content {
		font-size: 16px;
		color: #484848;
	}
	.swal2-popup #swal2-content{
		text-align: left;
	}
	.swal2-popup .swal2-styled.swal2-confirm{
		font-weight: normal;
		font-size:16px;
		color: #00CCC0;
		margin: .3125em 0;
	}
	.swal2-popup .swal2-styled.swal2-cancel{
		font-weight: normal;
		font-size:16px;
		color: #999999;
	}
	.swal2-popup .swal2-styled:focus {
		box-shadow: none !important;
	}
	.swal2-popup .swal2-actions{
		margin: 20px 0 0;
		border-top:1px solid #D2D2D2;
	}
</style>





// WEBPACK FOOTER //
// src/App.vue